import { Solution } from '@audibene/ta.utils-opportunity'

const solutionToDisplayText: Record<Solution, string> = {
  ADVANTAGE: 'Advantage',
  BEST_CHOICE: 'Best Choice',
  ECONOMY: 'Economy',
  DIRECT_SALE: 'Direct Sale',
  HEAR_TODAY: 'Hear Today',
  MEDICAL_ADVANTAGE: 'Medical Advantage',
  MEDICARE_ADVANTAGE: 'Medicare Advantage',
  OVER_THE_COUNTER: 'Over the Counter',
  RETAIL: 'Retail',
  STANDARD: 'Standard',
  TRUHEARING: 'TruHearing',
  YOUNG_HEARING_AID: 'Young Hearing Aid',
}

export { solutionToDisplayText }
